// Auto-generado por @xone-web/staticweb a partir de LoginWeb.xne.
// NO EDITAR: se regenera en cada build.
// Eventos lifecycle + custom + sintéticos (onclick/onchange por prop).

import type { XoneAPI } from "../xone-api";
import type { LoginWebFields } from "./LoginWeb.types";
export async function MAP_BTN_LOGIN_onclick(api: XoneAPI<LoginWebFields>): Promise<unknown> {
    const { self, This, ThisDataColl, ui, appData, $http, crypto, Bundle, console } = api;
    void self; void This; void ThisDataColl; void ui; void appData; void $http; void crypto; void Bundle; void console;
    
    await realizarLogin();
}